var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h4",
                { staticClass: "modal-title", attrs: { id: "myModalLabel" } },
                [_vm._v(_vm._s(_vm.$t("txtInventoryConfig")))]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c(
                  "div",
                  { staticClass: "btn-group mb-2" },
                  [
                    _c(
                      "TabButton",
                      {
                        attrs: { tab: "general" },
                        model: {
                          value: _vm.tab,
                          callback: function($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("inventory.edit.tab.general")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "TabButton",
                      {
                        attrs: { tab: "attachments" },
                        model: {
                          value: _vm.tab,
                          callback: function($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("inventory.edit.tab.attachments")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "TabButton",
                      {
                        attrs: { tab: "misc" },
                        model: {
                          value: _vm.tab,
                          callback: function($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("inventory.edit.tab.misc")))]
                    ),
                    _vm._v(" "),
                    _vm.inventory &&
                    _vm.inventory.bins &&
                    _vm.inventory.bins.length
                      ? _c(
                          "TabButton",
                          {
                            attrs: { tab: "bins" },
                            model: {
                              value: _vm.tab,
                              callback: function($$v) {
                                _vm.tab = $$v
                              },
                              expression: "tab"
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("inventory.edit.tab.bins")) +
                                "\n          "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "TabButton",
                      {
                        attrs: { tab: "contacts" },
                        model: {
                          value: _vm.tab,
                          callback: function($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("inventory.edit.tab.contacts")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("TabGeneral", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === "general",
                      expression: "tab === 'general'"
                    }
                  ],
                  attrs: { inventory: _vm.inventory }
                }),
                _vm._v(" "),
                _c("TabAttachments", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === "attachments",
                      expression: "tab === 'attachments'"
                    }
                  ],
                  attrs: { inventory: _vm.inventory, edit: _vm.edit }
                }),
                _vm._v(" "),
                _c("TabMisc", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === "misc",
                      expression: "tab === 'misc'"
                    }
                  ],
                  attrs: { inventory: _vm.inventory, edit: _vm.edit }
                }),
                _vm._v(" "),
                _c("TabInventoryBins", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === "bins",
                      expression: "tab === 'bins'"
                    }
                  ],
                  attrs: { inventory: _vm.inventory, edit: _vm.edit }
                }),
                _vm._v(" "),
                _c("TabInventoryContacts", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === "contacts",
                      expression: "tab === 'contacts'"
                    }
                  ],
                  attrs: { inventory: _vm.inventory, edit: _vm.edit }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.dismiss }
                },
                [_vm._v(_vm._s(_vm.$t("btnClose")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: { click: _vm.postSetting }
                },
                [_vm._v(_vm._s(_vm.$t("btnSave")))]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }